import { useOperatorSettingsStore } from "@/data/stores/operatorSettings";

import { Language } from "@/data/model/Enums";
import type { IMultiLanguageText } from "@/data/model/Shared";
import { Format } from "@/data/util/Format";

let clientLang: Language | undefined = undefined;
export let currentLanguage: Language = clientLanguage();

export function translate(textToTranslate?: IMultiLanguageText): string {
    if (textToTranslate == undefined) return "";

    return Format.translate(textToTranslate, currentLanguage);
}

export function translateByLocationLanguage(textToTranslate?: IMultiLanguageText): string {
    if (textToTranslate == undefined) return "";

    const operatorSettings = useOperatorSettingsStore();
    return Format.translate(textToTranslate, operatorSettings.locationLanguage ?? currentLanguage);
}

export function clientLocale(): string {
    switch (clientLanguage()) {
        case Language.German:
            return "de";
        case Language.French:
            return "fr";
        case Language.English:
            return "en-GB";
        case Language.Italian:
            return "it";
    }
}

export function getLanguageString(lang: Language) {
    switch (lang) {
        case Language.German:
            return "de";
        case Language.English:
            return "en";
        case Language.French:
            return "fr";
        case Language.Italian:
            return "it";
    }
}

export function clientLanguage(): Language {
    if (clientLang === undefined) {
        const language = window.navigator["userLanguage"] || window.navigator.language;
        if (language === "en" || language.includes("en")) clientLang = Language.English;
        else if (language === "de" || language.includes("de")) clientLang = Language.German;
        else if (language === "fr" || language.includes("fr")) clientLang = Language.French;
        else if (language === "it" || language.includes("it")) clientLang = Language.Italian;
        else clientLang = Language.English;
    }
    return clientLang;
}

export function changeLanguage(language: Language): void {
    currentLanguage = language;
}

export const languageSelectList = [
    {
        id: Language.English,
        name: Language[Language.English],
    },
    {
        id: Language.German,
        name: Language[Language.German],
    },
    {
        id: Language.French,
        name: Language[Language.French],
    },
    {
        id: Language.Italian,
        name: Language[Language.Italian],
    },
];
